/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Moicgross2Inputs */

const en_coinvestments_report_moicgross2 = /** @type {(inputs: Coinvestments_Report_Moicgross2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MOIC (Gross)`)
};

/**
* | output |
* | --- |
* | "MOIC (Gross)" |
*
* @param {Coinvestments_Report_Moicgross2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_moicgross2 = /** @type {((inputs?: Coinvestments_Report_Moicgross2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Moicgross2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_moicgross2(inputs)
});
export { coinvestments_report_moicgross2 as "coInvestments_report_moicGross" }